import { createContext, useContext } from "react";
import type { ProgramVersionId } from "../../types";

export const EditorProgramVersionIdContext = createContext<ProgramVersionId | null>(null);

export function useEditorProgramVersionId(): ProgramVersionId | null {
    return useContext(EditorProgramVersionIdContext);
}
